import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  FormControlLabel, Checkbox, Typography, Box, Link, Alert
} from '@mui/material';
import { Gavel as GavelIcon } from '@mui/icons-material';

function TermsAcceptanceDialog({ open, onAccept, loading }) {
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [cookieChecked, setCookieChecked] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);

  const allChecked = privacyChecked && cookieChecked && termsChecked;

  const handleAccept = () => {
    if (allChecked) {
      onAccept();
    }
  };

  return (
    <Dialog 
      open={open} 
      maxWidth="sm" 
      fullWidth
      disableEscapeKeyDown
      onClose={(e, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <GavelIcon color="primary" />
          <Typography variant="h6" fontWeight={600}>Terms Acceptance Required</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 3 }}>
          To continue using the platform, please read and accept our policies.
        </Alert>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox 
                checked={privacyChecked} 
                onChange={(e) => setPrivacyChecked(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                I have read and accept the{' '}
                <Link href="/privacy" target="_blank" rel="noopener">
                  Privacy Policy
                </Link>
              </Typography>
            }
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox 
                checked={cookieChecked} 
                onChange={(e) => setCookieChecked(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                I have read and accept the{' '}
                <Link href="/cookie" target="_blank" rel="noopener">
                  Cookie Policy
                </Link>
              </Typography>
            }
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox 
                checked={termsChecked} 
                onChange={(e) => setTermsChecked(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                I have read and accept the{' '}
                <Link href="/terms" target="_blank" rel="noopener">
                  Terms and Conditions
                </Link>
              </Typography>
            }
          />
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          By accepting, you confirm that you have read and understood all the above documents.
          Your acceptance will be recorded with timestamp.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button
          variant="contained"
          onClick={handleAccept}
          disabled={!allChecked || loading}
          fullWidth
          size="large"
        >
          {loading ? 'Processing...' : 'I Accept'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TermsAcceptanceDialog;
